import React from 'react';

const Tennis = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14.001'
            viewBox='0 0 14 14.001'
            className={className}
        >
            <g id='Tennis' transform='translate(-50.307 -86.694)'>
                <path
                    id='Path_3041'
                    data-name='Path 3041'
                    d='M58.572,100.641a9.545,9.545,0,0,0-8.18-8.165c.133-2.622,2.643-5.26,5.618-5.762a9.728,9.728,0,0,0,2.742,5.522A9.079,9.079,0,0,0,64.2,94.917,6.79,6.79,0,0,1,58.572,100.641Z'
                    transform='translate(0.014 0.003)'
                />
                <path
                    id='Path_3042'
                    data-name='Path 3042'
                    d='M56.553,86.716c3.306-.333,6.885,3.2,6.706,6.571C60.356,93.48,57.031,90.245,56.553,86.716Z'
                    transform='translate(1.041)'
                />
                <path
                    id='Path_3043'
                    data-name='Path 3043'
                    d='M56.964,99.637c-3.731.176-6.923-3.673-6.64-6.629C53.353,92.979,56.775,96.368,56.964,99.637Z'
                    transform='translate(0 1.053)'
                />
            </g>
        </svg>
    );
};

export default Tennis;
